import { gql } from "@apollo/client";

export const GET_SALES_SAVED_VIEWS = gql`
  query GetSalesSavedViews {
    me {
      id
      salesSavedViews
    }
  }
`;

export const CREATE_SALES_SAVED_VIEW = gql`
  mutation CreateSalesSavedView($name: String!, $config: JSONObject!) {
    createSalesSavedView(name: $name, config: $config)
  }
`;

export const UPDATE_SALES_SAVED_VIEW = gql`
  mutation UpdateSalesSavedView($id: Int!, $name: String, $config: JSONObject) {
    updateSalesSavedView(id: $id, name: $name, config: $config)
  }
`;

export const UPDATE_SALES_SAVED_VIEW_ORDERING = gql`
  mutation UpdateSalesSavedViewOrdering($ids: [Int!]!) {
    updateSalesSavedViewOrdering(ids: $ids)
  }
`;

export const UPDATE_SALES_SAVED_VIEW_ORDERING_TO_ALL_ACCOUNT_MANAGERS = gql`
  mutation UpdateSalesSavedViewOrderingToAllAccountManagers($ids: [Int!]!) {
    updateSalesSavedViewOrderingToAllAccountManagers(ids: $ids)
  }
`;

export const CREATE_HIDDEN_SALES_SAVED_VIEW_TEMPLATE = gql`
  mutation CreateHiddenSalesSavedViewTemplate($id: Int!) {
    createClientHiddenSalesSavedViewTemplate(id: $id)
  }
`;

export const DELETE_SALES_SAVED_VIEW = gql`
  mutation DeleteSalesSavedView($id: Int!) {
    deleteSalesSavedView(id: $id)
  }
`;
